import React, { useEffect } from "react";
import { navigate } from "gatsby";
import { useI18next } from "../../../../plugins/gatsby-plugin-ap-i18next/src/useI18next";

import {
    surveyEnd,
    portrait,
    success,
    happyEnd,
    button,
    imgWrapper,
    logo,
    header,
    surveySuccess,
    surveySuccessLeftWrapper,
    surveySuccessRightWrapper,
    surveySuccessRightContent,
} from "./survey-success.module.scss";
import PortraitSurvey from "../../../assets/images/svg/portrait-survey.svg";
import Success from "../../../assets/images/svg/success.svg";
import getTranslationKey from "../../../utils/get-translation-key";
import { getAbsolutePath } from "../../utility/routes.utility";

import MainLayout from "../../../layouts/main-layout";
import Section from "../../../components/molecules/section";
import Button from "../../../components/atoms/button";
import Logo from "../../../components/atoms/logo";
import RegisterForm from "../../auth/forms/register-form";
import { selectFillSurveyToken } from "../../../redux/survey-fill/survey-fill.selectors";
import { useSelector } from "react-redux";
import TwoBoxSection from "../../../components/organisms/sections/common/two-box-section";
import HeaderSurvey from "../../../components/organisms/headers/headerSurvey";
const SurveySuccess = () => {
    const { t } = useI18next();
    const surveyTranslations = getTranslationKey("survey");
    const surveySessionToken = useSelector(selectFillSurveyToken);


    const navToGenerator = async () => {
        await navigate(getAbsolutePath("GENERATOR_NEW_STYLIZATION"), {
            state: { isSurveySuccessRedirect: true },
            replace: true,
        });
    };

    return (
        <MainLayout HeaderComponent={<HeaderSurvey className={header} />} footer={false} isSurvey={true}>
            <TwoBoxSection
                className={surveySuccess}
                classNameLeftWrapper={surveySuccessLeftWrapper}
                classNameRightWrapper={surveySuccessRightWrapper}
                title={"Udało Ci się ukończyć ankietę."}
                text={<div className={surveySuccessRightContent}>
                    <p>Potrzebuje jeszcze Twój email aby założyć konto i tworzyć spersonalizowane stylizacje dla Ciebie!</p>
                    <RegisterForm context={{ surveySessionToken }} showLogin={false}></RegisterForm>
                </div>} />
        </MainLayout>
    );
};

export default SurveySuccess;
